const SET_TITLE = "SET_TITLE"
const SET_NOTE = "SET_NOTE"
const TOGGLE_TRASH = "TOGGLE_TRASH";
const SET_LABELS = "SET_LABELS";
const SET_COLOR = "SET_COLOR";
const SET_PRIORITY = "SET_PRIORITY";
const TOGGLE_PINNED = "TOGGLE_PINNED";
const RESET = "RESET"

export {
  SET_TITLE,
  SET_NOTE,
  TOGGLE_TRASH,
  SET_LABELS,
  SET_COLOR,
  SET_PRIORITY,
  TOGGLE_PINNED,
  RESET
};
